import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Exercise } from './workout-tracker.model';

@Component({
    selector: 'app-exercise-list',
    templateUrl: './exercise-list.component.html',
    styleUrls: ['./exercise-list.component.scss'],
    standalone: false
})
export class ExerciseListComponent {
  @Input() exercises: Exercise[] = [];
  @Output() addExercise = new EventEmitter<void>();
  @Output() editExercise = new EventEmitter<Exercise>();
  @Output() deleteExercise = new EventEmitter<Exercise>();

  onAddExercise() {
    this.addExercise.emit();
  }
  onEditExercise(ex: Exercise) {
    this.editExercise.emit(ex);
  }
  onDeleteExercise(ex: Exercise) {
    this.deleteExercise.emit(ex);
  }
}

